<template>
  <page-wrap>
    <grid
      ref="grid"
      :config="gridConfig"
    />
    <editor
      :config="{id: gridConfig.id, api: 'RFQ2s/Get/'}"
    />
  </page-wrap>
</template>

<script>
import gridConfig from './GridConfig.js'

export default {
  name: 'RepairExchangeTd',
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'Rfq2List' */ './Editor')
  },
  computed: {
    isHighPermission () {
      return this.$store.getters.isHighPermission
    },
    currentEmployeeID () {
      return this.$store.state.currentUser.employeeID
    },
    gridConfig () {
      return gridConfig({ employeeID: this.isHighPermission ? null : this.currentEmployeeID })
    }
  }
}
</script>
